import classes from '../index.module.css';
import React, { useEffect, useState } from 'react';
import TabsComponent from '../../../../components/Tabs/Tabs';
import MFRRMonitoring from './MFRRMonitoring';
import MfrrLogs from './MfrrLogs';
import { useLoader, useQueryParamWithDefault } from '../../../../hooks';
import { NumberParam, ObjectParam } from 'use-query-params';
import MfrrPowerLogs from './MfrrPowerLogs';
import RedisViewer from './RedisViewer';
import { RootAfrrService } from '../../../../services/RootAfrrService';
import { toast } from 'react-toastify';

const MFRRMonitoringEvents = ({ cId, selectedEicCode, setSelectedEicCode, eicCodeOptions }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'DK1',
            component: (
                <>
                    <MFRRMonitoring area={'DK1'} selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'DK2',
            component: (
                <>
                    <MFRRMonitoring area={'DK2'} selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

const MFRRMonitoringCommandLogs = ({ cId, selectedEicCode, setSelectedEicCode, eicCodeOptions }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'MFRR Logs',
            component: (
                <>
                    <MfrrLogs selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'MFRR Power Logs',
            component: (
                <>
                    <MfrrPowerLogs selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

const MFRRMonitoringMain = ({ cId }) => {
    const [startLoader, stopLoader] = useLoader();

    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);
    const [eicCodeOptions, setEicCodeOption] = useState([]);
    const [selectedEicCode, setSelectedEicCode] = useQueryParamWithDefault('eicCode', ObjectParam, eicCodeOptions[0], cId);

    useEffect(() => {
        getEicCodes();
    }, []);

    const getEicCodes = () => {
        RootAfrrService.GetEicCodes(startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleError = (err) => {
        toast.error(err?.response?.data?.message);
    };

    const handleSuccess = ({ data }) => {
        const temp = data.data
            ?.filter((item) => item.MFRR?.redisConfig)
            .map((item) => ({
                label: item.name,
                value: item.EICCode,
            }));
        setEicCodeOption(temp);
        temp.length ? setSelectedEicCode(temp[0]) : setSelectedEicCode('');
    };

    let tabs = [
        {
            name: 'Events',
            component: (
                <>
                    <MFRRMonitoringEvents selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Command Logs',
            component: (
                <>
                    <MFRRMonitoringCommandLogs selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 2,
        },
        {
            name: 'Redis Viewer',
            component: (
                <>
                    <RedisViewer selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default MFRRMonitoringMain;
